<div class="selector-container" [ngStyle]="{ 'width':width }">
  <div class="select-custom"
    [ngClass]="{ 'focused' : focused }"
    (click)="toggleFocus()"
    (mouseenter)="onMouseOver()"
    (mouseleave)="onMouseLeft()">
    <div class="selected-item" [ngClass]="{ 'placeholder-text' : selectedItem == '' }">
      @if (titleCase) {
        {{ (selectedItem != '' ? selectedItem : placeHolder) | titlecase }}
      }
      @if (titleCase == false ) {
        {{ (selectedItem != '' ? selectedItem : placeHolder) }}
      }
    </div>
    <em class="arrow-down"
    [ngClass]="{ 'arrow-focused' : hovered || focused }"></em>
  </div>
  @if (focused) {
    <div class="select-custom-options"
      (mouseleave)="hideDropdown()">
      @for (i of items; track i; let index = $index) {
        <div [ngClass]="{ 'selected' : i === selectedItem }"
          (click)="onItemSelected(i)">
          @if (titleCase) {
            {{ i | titlecase }}
          }
          @if (titleCase == false ) {
            {{ i }}
          }
        </div>
      }
    </div>
  }
</div>
